import { ErrorMessage, Rule } from '~domain/model/core/validation/rule';
import { BaseValidator } from '~domain/validators/core/base-validator';

// Validate value exists in the options
export class InclusionValidator<T> extends BaseValidator<T> {
  protected rules: Rule<T>[] = [this.createNullRule(), this.validateContent];
  private errorMessage: string;
  private validValues: T[];

  constructor(validValues: T[], errorMessage?: string) {
    super();
    this.validValues = validValues;
    this.errorMessage = errorMessage || 'validation.error.choiceNotIncluded';
  }

  private validateContent(value: T): ErrorMessage {
    if (!this.validValues.includes(value)) return this.errorMessage;
  }
}
